export default function Linebreak({ className = "my-8" }) {
  return <hr className={`border-border-gray border-t ${className}`} />;
}
